import React, { useEffect, useState } from "react";
import { adminGet, adminPost } from "../common/api/api";

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchUsers = async () => {
    setLoading(true);
    const data = await adminGet("/allusers");
    setUsers(Array.isArray(data) ? data : []);
    setLoading(false);
  };

  useEffect(() => { fetchUsers(); }, []);

  const deleteUser = async (id) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;
    await adminPost("/deleteuser", { id });
    fetchUsers();
  };

  const filtered = users.filter(
    (u) =>
      (u.name || "").toLowerCase().includes(search.toLowerCase()) ||
      (u.email || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <div>
          <h1 className="text-2xl font-bold text-white">Users</h1>
          <p className="text-sm text-[#4a5568] mt-0.5">Manage registered users</p>
        </div>
        <span className="text-sm text-[#a0aec0] bg-white/[0.04] px-4 py-1.5 rounded-full border border-white/[0.07]">
          {users.length} total users
        </span>
      </div>

      {/* Search */}
      <input
        type="text"
        placeholder="Search by name or email..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="w-full max-w-sm mb-5 bg-white/[0.05] border border-white/[0.1] rounded-lg px-4 py-2.5 text-[#e2e8f0] placeholder-[#4a5568] focus:outline-none focus:border-[#00d4ff]/60 transition-all text-sm"
      />

      {loading ? (
        <div className="text-[#4a5568] py-16 text-center">Loading users...</div>
      ) : (
        <>
          {/* Scrollable table wrapper */}
          <div className="overflow-x-auto rounded-xl border border-white/[0.08]">
            <div className="min-w-[580px]">
          {/* Table Header */}
          <div className="grid grid-cols-[40px_1fr_1.5fr_110px_90px] gap-3 px-4 py-3 bg-white/[0.05] rounded-t-xl text-[#4a5568] text-xs font-bold uppercase tracking-wider">
            <span>#</span>
            <span>Name</span>
            <span>Email</span>
            <span>Joined</span>
            <span>Action</span>
          </div>

          {/* Rows */}
          <div className="rounded-b-xl overflow-hidden">
            {filtered.length === 0 ? (
              <div className="py-16 text-center text-[#4a5568]">No users found.</div>
            ) : (
              filtered.map((user, i) => (
                <div
                  key={user._id}
                  className="grid grid-cols-[40px_1fr_1.5fr_110px_90px] gap-3 items-center px-4 py-3.5 border-b border-white/[0.05] hover:bg-white/[0.02] last:border-b-0 transition-colors"
                >
                  <span className="text-xs text-[#4a5568]">{i + 1}</span>
                  <div className="flex items-center gap-2.5 min-w-0">
                    {user.profilePicture ? (
                      <img src={user.profilePicture} alt="" className="w-8 h-8 rounded-full object-cover shrink-0 border border-white/[0.15]" />
                    ) : (
                      <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#00d4ff] to-[#7c3aed] flex items-center justify-center text-[#060c18] text-xs font-bold shrink-0">
                        {((user.name || user.email || "?")[0] || "?").toUpperCase()}
                      </div>
                    )}
                    <span className="text-[#e2e8f0] text-sm truncate">{user.name || <span className="text-[#4a5568]">—</span>}</span>
                  </div>
                  <span className="text-[#a0aec0] text-sm truncate">{user.email}</span>
                  <span className="text-[#4a5568] text-xs">
                    {user.date ? new Date(user.date).toLocaleDateString() : "—"}
                  </span>
                  <button
                    onClick={() => deleteUser(user._id)}
                    className="text-xs text-red-400 hover:text-red-300 hover:bg-red-500/10 px-3 py-1.5 rounded-lg transition-colors cursor-pointer border border-red-500/20 hover:border-red-500/40"
                  >
                    Delete
                  </button>
                </div>
              ))
            )}
          </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminUsers;
